import React, { useState } from 'react';

import Confirm from 'components/shared/Modal/Confirm/Confirm';
import Popover from 'components/shared/Popovers/Popover/Popover';
import NewServiceModal from 'components/shared/NewServiceModal/NewServiceModal';

const AddServiceActions = (params) => {
  const { data, context } = params;
  const isAdminContext = context?.isAdminContext;
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const options = [
    {
      label: 'Edit',
      onClick: () => setShowEditModal(true),
      icon: 'edit-2-mono'
    },
    {
      label: 'Remove',
      onClick: () => setShowDeleteModal(true),
      icon: 'trash-mono'
    }
  ];

  const onEditModalToggle = () => {
    setShowEditModal((prev) => !prev);
  };

  const handleRemove = () => {
    context?.onRemove?.(data.code);
    setShowDeleteModal(false);
  };

  const onSave = async (updatedService) => {
    const updatedData = {
      name: updatedService.name,
      cpt_description: updatedService.name,
      self_pay: updatedService.total_cost_cents,
      total_cost_cents: updatedService.total_cost_cents,
      standard_charge: updatedService.standard_charge,
      par_amount: updatedService.par_amount || data.par_amount,
      also_known_as: updatedService.also_known_as,
      description: updatedService.description,
      time_length: updatedService.time_length,
      charge_type: updatedService.charge_type,
      color: updatedService.color,
      image: updatedService.image
    };

    if (context?.setLocalEdits) {
      context.setLocalEdits((prev) => ({
        ...prev,
        [data.code]: updatedData
      }));
    }

    if (context?.gridApi) {
      const rowNode = context.gridApi.getRowNode(data.code);
      if (rowNode) {
        rowNode.setData({ ...data, ...updatedData });
      }
    }

    onEditModalToggle();
  };

  const serviceData = {
    ...data,
    id: `local-${data.code}`,
    name: data.name || data.cpt_description,
    procedure_code: data.code,
    total_cost_cents: data.self_pay || data.total_cost_cents,
    standard_charge: data.standard_charge,
    par_amount: data.par_amount
  };

  return (
    <div className="flex h-full items-center justify-center">
      <Popover
        isFixed
        options={options}
        position="left"
        icon="context-menu-horizontal"
        className="flex flex-1 justify-center self-center"
      />
      {showEditModal && (
        <NewServiceModal
          service={serviceData}
          isOpen={showEditModal}
          onClose={onEditModalToggle}
          onSave={onSave}
          isAdminContext={isAdminContext}
          practice={context?.practice}
        />
      )}
      {showDeleteModal && (
        <Confirm
          variant="danger"
          title="Remove service"
          icon="trash-mono"
          message="Are you sure you want to remove this service from the list?"
          handleOpen={showDeleteModal}
          handleClose={() => setShowDeleteModal(false)}
          footerActions={{
            primary: {
              text: 'Remove service',
              onClick: handleRemove,
              color: 'danger'
            }
          }}
        />
      )}
    </div>
  );
};

export default AddServiceActions;
